export const SHOP_COLLECTION_HANDLES = Object.freeze({
  allProducts: 'frontpage',
  bestSellers: 'best-sellers',
  installationService: 'installation-service',
  reverseOsmosisSystems: 'reverse-osmosis-systems',
  roFaucets: 'ro-faucets',
  roFaucetsAccessories: 'ro-faucets-accessories',
  saltFreeWaterConditioners: 'salt-free-water-conditioners',
  uvSystems: 'uv-systems',
  waterFilterCartridges: 'water-filter-cartridges',
  waterSofteners: 'water-softeners',
  waterSoftenersConditioners: 'water-softeners-conditioners',
  wholeHouseChlorineFilters: 'whole-house-chlorine-filters',
  wholeHomeWaterTreatment: 'whole-home-water-treatment',
});

export function getShopCollectionPath(handle) {
  return `/collections/${handle}`;
}
